import { minorUnitData } from './data';
import type { Value } from './types';

const defaultMinorUnit = 2;

export const minorUnitForCurrencyCode = (currencyCode: string): number => {
  const minorUnit = minorUnitData[currencyCode];

  if (typeof minorUnit === 'undefined') {
    return defaultMinorUnit;
  }

  return minorUnit;
};

export const shiftValueByMinorUnit = (
  value: Value,
  minorUnit: number,
): Value => {
  const minorUnitFactor = 10 ** minorUnit;

  if (typeof value === 'number') {
    return value / minorUnitFactor;
  }

  // Cast does not lose precision as minorUnitFactor will always be an integer
  return value / BigInt(minorUnitFactor);
};
